import { Check, Copy } from "lucide-react-native";
import { FC } from "react";
import { ColorValue } from "react-native";

import { Box, Pressable } from "@/components/ui";

interface ChartCopyButtonProps {
  compact: boolean;
  copied: boolean;
  onPress: () => void;
  textColor: ColorValue;
}

/**
 * Hover-reveal "copy chart to clipboard" button shared by the question-result
 * cards. Declared at module scope (not inside each result component) so React
 * doesn't recreate the component type on every render.
 */
const ChartCopyButton: FC<ChartCopyButtonProps> = ({
  compact,
  copied,
  onPress,
  textColor,
}) => (
  <Box
    className={`absolute z-10 opacity-0 group-hover:opacity-100 transition-opacity ${compact ? "top-0 right-0" : "top-4 right-4"}`}
  >
    <Pressable onPress={onPress}>
      <Box className="p-2 rounded-lg bg-background-100 dark:bg-background-800 hover:bg-background-200 dark:hover:bg-background-700 transition-colors">
        {copied ? (
          <Check color="rgb(var(--color-success-500))" size={16} />
        ) : (
          <Copy color={textColor} size={16} />
        )}
      </Box>
    </Pressable>
  </Box>
);

export default ChartCopyButton;
